var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRewardFollow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1803_3829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0326 10.8776C18.5269 10.7173 19.1069 10.625 19.7273 10.625C21.5348 10.625 23 11.4085 23 12.375C23 13.3415 21.5348 14.125 19.7273 14.125C19.1069 14.125 18.5269 14.0327 18.0326 13.8724M18.0326 10.8776C17.1458 10.1961 15.6703 9.75 14 9.75C12.3297 9.75 10.8542 10.1961 9.96743 10.8776M18.0326 10.8776C18.5851 11.3023 18.9091 11.8184 18.9091 12.375C18.9091 12.9316 18.5851 13.4477 18.0326 13.8724M18.0326 13.8724C17.1458 14.5539 15.6703 15 14 15C12.3297 15 10.8542 14.5539 9.96743 13.8724M9.96743 10.8776C9.47311 10.7173 8.89308 10.625 8.27273 10.625C6.46525 10.625 5 11.4085 5 12.375C5 13.3415 6.46525 14.125 8.27273 14.125C8.89308 14.125 9.47311 14.0327 9.96743 13.8724M9.96743 10.8776C9.41486 11.3023 9.09091 11.8184 9.09091 12.375C9.09091 12.9316 9.41486 13.4477 9.96743 13.8724M16.4545 3.625C16.4545 5.07475 15.3556 6.25 14 6.25C12.6444 6.25 11.5455 5.07475 11.5455 3.625C11.5455 2.17525 12.6444 1 14 1C15.3556 1 16.4545 2.17525 16.4545 3.625ZM21.3636 6.25C21.3636 7.2165 20.631 8 19.7273 8C18.8235 8 18.0909 7.2165 18.0909 6.25C18.0909 5.2835 18.8235 4.5 19.7273 4.5C20.631 4.5 21.3636 5.2835 21.3636 6.25ZM9.90909 6.25C9.90909 7.2165 9.17647 8 8.27273 8C7.36899 8 6.63636 7.2165 6.63636 6.25C6.63636 5.2835 7.36899 4.5 8.27273 4.5C9.17647 4.5 9.90909 5.2835 9.90909 6.25Z",
    stroke: "#F55139",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1803_3829",
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 23.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1803_3829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1803_3829",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRewardFollow);
export default __webpack_public_path__ + "static/media/icon_reward_follow.89d1464f3efe97eaeda1252f22e30d7e.svg";
export { ForwardRef as ReactComponent };